// extracted by mini-css-extract-plugin
export default {"header":"ReleaseDetails_header__ah1Ve","customHeader":"ReleaseDetails_customHeader__d92zY","pageContainer":"ReleaseDetails_pageContainer__vsei1"};